export default __webpack_public_path__ + "static/media/a009-ransomware-01.1190d3d5.svg";